import { Table, Text } from '@radix-ui/themes'
import cn from 'classnames'
import { formatM3, type CaptureDetail } from '~/features/index-captures/alignment'
import { roundLabel } from '~/features/index-captures/labels'
import { formatTimestamp } from '~/utils/date'
import { CaptureStatusBadge } from './CaptureBadges'

interface CaptureRoundsProps {
  rounds: CaptureDetail['rounds']
  currentCaptureId: string
  onSelect: (captureId: string) => void
}

export const CaptureRounds = ({ rounds, currentCaptureId, onSelect }: CaptureRoundsProps) => {
  if (rounds.length < 2) return null

  return (
    <Table.Root size="1" variant="ghost">
      <Table.Header>
        <Table.Row>
          <Table.ColumnHeaderCell>Round</Table.ColumnHeaderCell>
          <Table.ColumnHeaderCell>Status</Table.ColumnHeaderCell>
          <Table.ColumnHeaderCell>Index read</Table.ColumnHeaderCell>
          <Table.ColumnHeaderCell>Photo taken</Table.ColumnHeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {rounds.map((round) => (
          <Table.Row
            key={round.id}
            onClick={() => onSelect(round.id)}
            className={cn(
              'cursor-pointer hover:bg-[var(--gray-a3)]',
              round.id === currentCaptureId && 'bg-[var(--accent-a3)]'
            )}
          >
            <Table.Cell>
              <Text size="2" weight={round.id === currentCaptureId ? 'bold' : 'regular'}>
                {roundLabel(round.round)}
              </Text>
            </Table.Cell>
            <Table.Cell>
              <CaptureStatusBadge status={round.status} outcome={round.outcome} />
            </Table.Cell>
            <Table.Cell>
              <Text size="2">{formatM3(round.readingValue)}</Text>
            </Table.Cell>
            <Table.Cell>
              <Text size="2">{formatTimestamp(round.capturedAt)}</Text>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table.Root>
  )
}
